/**
 * Compatibility layer for SDK type aliases.
 *
 * This file provides backward-compatible type aliases for code migrating
 * from the old SDK to the new Orval-generated SDK.
 *
 * @deprecated All exports from this file are deprecated. Import directly from the SDK instead.
 */

import type {
  AdvanceInvoice,
  AdvanceInvoiceList,
  CreateAdvanceInvoice,
  CreateCreditNote,
  CreateCustomerBody,
  CreateDeliveryNote,
  CreateEntityBody,
  CreateEstimate,
  CreateInvoice,
  CreateItemBody,
  CreatePaymentBody,
  CreateTaxBody,
  CreditNote,
  CreditNoteList,
  DeliveryNote,
  DeliveryNoteList,
  Estimate,
  EstimateList,
  GetActivities200,
  GetActivities200DataItem,
  GetCustomers200,
  GetEntities200,
  GetFursSettings200,
  GetItems200,
  GetPayments200,
  GetTaxes200,
  Invoice,
  InvoiceList,
  PaginationMetadata,
  PatchEntityBody,
} from "./generated/model";

// ============================================================================
// RESOURCE TYPE ALIASES
// ============================================================================

/** @deprecated Use `GetActivities200DataItem` from `@spaceinvoices/js-sdk` */
export type Activity = GetActivities200DataItem;

/** @deprecated Use `AdvanceInvoice` from `@spaceinvoices/js-sdk` */
export type AdvanceInvoiceWithItems = AdvanceInvoice;

/** @deprecated Use `CreditNote` from `@spaceinvoices/js-sdk` */
export type CreditNoteWithItems = CreditNote;

/** @deprecated Use `DeliveryNote` from `@spaceinvoices/js-sdk` */
export type DeliveryNoteWithItems = DeliveryNote;

/** @deprecated Use `Estimate` from `@spaceinvoices/js-sdk` */
export type EstimateWithItems = Estimate;

/** @deprecated Use `Invoice` from `@spaceinvoices/js-sdk` */
export type InvoiceWithItems = Invoice;

// ============================================================================
// CREATE REQUEST TYPE ALIASES
// ============================================================================

/** @deprecated Use `CreateAdvanceInvoice` from `@spaceinvoices/js-sdk` */
export type CreateAdvanceInvoiceRequest = CreateAdvanceInvoice;

/** @deprecated Use `CreateCreditNote` from `@spaceinvoices/js-sdk` */
export type CreateCreditNoteRequest = CreateCreditNote;

/** @deprecated Use `CreateDeliveryNote` from `@spaceinvoices/js-sdk` */
export type CreateDeliveryNoteRequest = CreateDeliveryNote;

/** @deprecated Use `CreateCustomerBody` from `@spaceinvoices/js-sdk` */
export type CreateCustomerRequest = CreateCustomerBody;

/** @deprecated Use `CreateEntityBody` from `@spaceinvoices/js-sdk` */
export type CreateEntityRequest = CreateEntityBody;

/** @deprecated Use `CreateEstimate` from `@spaceinvoices/js-sdk` */
export type CreateEstimateRequest = CreateEstimate;

/** @deprecated Use `CreateInvoice` from `@spaceinvoices/js-sdk` */
export type CreateInvoiceRequest = CreateInvoice;

/** @deprecated Use `CreateItemBody` from `@spaceinvoices/js-sdk` */
export type CreateItemRequest = CreateItemBody;

/** @deprecated Use `CreatePaymentBody` from `@spaceinvoices/js-sdk` */
export type CreatePaymentRequest = CreatePaymentBody;

/** @deprecated Use `CreateTaxBody` from `@spaceinvoices/js-sdk` */
export type CreateTaxRequest = CreateTaxBody;

// ============================================================================
// PATCH REQUEST TYPE ALIASES
// ============================================================================

/** @deprecated Use `PatchEntityBody` from `@spaceinvoices/js-sdk` */
export type PatchEntityRequest = PatchEntityBody;

// ============================================================================
// RESPONSE TYPE ALIASES
// ============================================================================

/** @deprecated Use `GetActivities200` from `@spaceinvoices/js-sdk` */
export type GetActivitiesResponse = GetActivities200;

/** @deprecated Use `AdvanceInvoiceList` from `@spaceinvoices/js-sdk` */
export type GetAdvanceInvoicesResponse = AdvanceInvoiceList;

/** @deprecated Use `CreditNoteList` from `@spaceinvoices/js-sdk` */
export type GetCreditNotesResponse = CreditNoteList;

/** @deprecated Use `DeliveryNoteList` from `@spaceinvoices/js-sdk` */
export type GetDeliveryNotesResponse = DeliveryNoteList;

/** @deprecated Use `GetCustomers200` from `@spaceinvoices/js-sdk` */
export type GetCustomersResponse = GetCustomers200;

/** @deprecated Use `GetCustomers200` from `@spaceinvoices/js-sdk` */
export type GetCustomers200Response = GetCustomers200;

/** @deprecated Use `GetEntities200` from `@spaceinvoices/js-sdk` */
export type GetEntitiesResponse = GetEntities200;

/** @deprecated Use `EstimateList` from `@spaceinvoices/js-sdk` */
export type GetEstimatesResponse = EstimateList;

/** @deprecated Use `EstimateList` from `@spaceinvoices/js-sdk` */
export type GetEstimates200Response = EstimateList;

/** @deprecated Use `GetFursSettings200` from `@spaceinvoices/js-sdk` */
export type GetFursSettingsResponse = GetFursSettings200;

/** @deprecated Use `GetFursSettings200` from `@spaceinvoices/js-sdk` */
export type GetFursSettings200Response = GetFursSettings200;

/** @deprecated Use `InvoiceList` from `@spaceinvoices/js-sdk` */
export type GetInvoicesResponse = InvoiceList;

/** @deprecated Use `GetItems200` from `@spaceinvoices/js-sdk` */
export type GetItemsResponse = GetItems200;

/** @deprecated Use `GetItems200` from `@spaceinvoices/js-sdk` */
export type GetItems200Response = GetItems200;

/** @deprecated Use `GetPayments200` from `@spaceinvoices/js-sdk` */
export type GetPaymentsResponse = GetPayments200;

/** @deprecated Use `GetTaxes200` from `@spaceinvoices/js-sdk` */
export type GetTaxesResponse = GetTaxes200;

/** @deprecated Use `GetTaxes200` from `@spaceinvoices/js-sdk` */
export type GetTaxes200Response = GetTaxes200;

// ============================================================================
// GENERIC PAGINATED RESPONSE TYPE
// ============================================================================

/**
 * @deprecated Use specific list types (e.g. `InvoiceList`, `EstimateList`) instead.
 */
export interface PaginatedResponse<T> {
  data: T[];
  pagination: PaginationMetadata;
}

// ============================================================================
// CONFIGURATION CLASS
// ============================================================================

/**
 * @deprecated Use `new SpaceInvoices({ accessToken, basePath })` instead.
 */
export class Configuration {
  basePath?: string;
  accessToken?: string;

  constructor(config?: { basePath?: string; accessToken?: string }) {
    this.basePath = config?.basePath;
    this.accessToken = config?.accessToken;
  }
}
